import type { WcControl } from '../protocol/WebCodecsTypes';
import { WebCodecsWire } from '../protocol/WebCodecsWire';
import type { WcWorkerPort } from './WebCodecsClientTypes';

/** Debits before transfer. Worker acknowledgement, not postMessage return, restores capacity. */
export class WebCodecsIngress {
  static readonly capacity = 1024 * 1024;
  private outstanding = 0;
  private closed = false;
  constructor(private readonly worker: WcWorkerPort, private readonly overflow: () => void) {}
  fragment(bytes: ArrayBuffer, receivedUs: number): boolean {
    const size = bytes.byteLength;
    if (!this.reserve(size)) return false;
    try { this.worker.postMessage({ type: 'fragment', bytes, receivedUs }, [bytes]); }
    catch (error) { this.outstanding -= size; throw error; }
    return true;
  }
  control(message: WcControl): boolean {
    const size = WebCodecsWire.EncodeControl(message).byteLength;
    if (!this.reserve(size)) return false;
    try { this.worker.postMessage({ type: 'control', message }); }
    catch (error) { this.outstanding -= size; throw error; }
    return true;
  }
  release(bytes: number): void {
    if (!Number.isSafeInteger(bytes) || bytes < 0 || bytes > this.outstanding) throw new Error('Invalid worker ingress credit');
    this.outstanding -= bytes;
  }
  getOutstandingBytes(): number { return this.outstanding; }
  close(): void { this.closed = true; this.outstanding = 0; }
  private reserve(bytes: number): boolean {
    if (this.closed) return false;
    if (bytes > WebCodecsIngress.capacity - this.outstanding) { this.overflow(); return false; }
    this.outstanding += bytes; return true;
  }
}
